import axios from 'axios'

// ==================== 通行组配置管理接口 ====================

/**
 * 分页查询通行组配置
 * @param {Object} data - 查询参数 {page, size, groupName}
 */
export function getVehicleGroupConfigPage(data) {
    return axios({
        method: 'get',
        url: '/user/vehicleGroupConfig/pageList',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 获取通行组配置详情
 * @param {Number} id - 配置ID
 */
export function getVehicleGroupConfigDetail(id) {
    return axios({
        method: 'get',
        url: '/user/vehicleGroupConfig/detail',
        params: { id },
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 新增通行组配置
 * @param {Object} data - 配置对象
 */
export function addVehicleGroupConfig(data) {
    return axios({
        method: 'post',
        url: '/user/vehicleGroupConfig/add',
        data: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 更新通行组配置
 * @param {Object} data - 配置对象
 */
export function updateVehicleGroupConfig(data) {
    return axios({
        method: 'post',
        url: '/user/vehicleGroupConfig/update',
        data: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 删除通行组配置
 * @param {Number} id - 配置ID
 */
export function deleteVehicleGroupConfig(id) {
    return axios({
        method: 'get',
        url: '/user/vehicleGroupConfig/delete',
        params: { id },
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 启用通行组配置
 * @param {Number} id - 配置ID
 */
export function activateVehicleGroupConfig(id) {
    return axios({
        method: 'get',
        url: '/user/vehicleGroupConfig/activate',
        params: { id },
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 禁用通行组配置
 * @param {Number} id - 配置ID
 */
export function deactivateVehicleGroupConfig(id) {
    return axios({
        method: 'get',
        url: '/user/vehicleGroupConfig/deactivate',
        params: { id },
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 获取所有启用的配置
 */
export function getActiveVehicleGroupConfigs() {
    return axios({
        method: 'get',
        url: '/user/vehicleGroupConfig/getActiveConfigs',
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 导入车辆到通行组
 * @param {Number} groupId - 通行组ID
 * @param {File} file - Excel文件
 */
export function importVehiclesToGroup(groupId, file) {
    const formData = new FormData()
    formData.append('groupId', groupId)
    formData.append('file', file)
    
    return axios({
        method: 'post',
        url: '/user/vehicleGroupConfig/importVehicles',
        data: formData,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
            'Content-Type': 'multipart/form-data'
        }
    })
}

// ==================== 车辆关联管理接口 ====================

/**
 * 分页查询通行组内的车辆
 * @param {Object} data - 查询参数 {page, size, groupId}
 */
export function getVehicleGroupRelationPage(data) {
    return axios({
        method: 'get',
        url: '/user/vehicleGroupRelation/pageByGroupId',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 根据车牌号查询所属通行组
 * @param {String} carNo - 车牌号
 */
export function getVehicleGroupByCarNo(carNo) {
    return axios({
        method: 'get',
        url: '/user/vehicleGroupRelation/listByCarNo',
        params: { carNo },
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 添加单个车辆到通行组
 * @param {Number} groupId - 通行组ID
 * @param {String} carNo - 车牌号
 */
export function addVehicleToGroup(groupId, carNo) {
    return axios({
        method: 'post',
        url: '/user/vehicleGroupRelation/addVehicle',
        params: { groupId, carNo },
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 批量添加车辆到通行组
 * @param {Number} groupId - 通行组ID
 * @param {String} carNos - 多个车牌号，用逗号分隔
 */
export function batchAddVehiclesToGroup(groupId, carNos) {
    return axios({
        method: 'post',
        url: '/user/vehicleGroupRelation/batchAddVehicles',
        params: { groupId, carNos },
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 从通行组移除车辆
 * @param {Number} groupId - 通行组ID
 * @param {String} carNos - 多个车牌号，用逗号分隔
 */
export function removeVehiclesFromGroup(groupId, carNos) {
    return axios({
        method: 'post',
        url: '/user/vehicleGroupRelation/removeVehicles',
        params: { groupId, carNos },
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 获取通行组的所有车牌号
 * @param {Number} groupId - 通行组ID
 */
export function getCarNosByGroupId(groupId) {
    return axios({
        method: 'get',
        url: '/user/vehicleGroupRelation/getCarNosByGroupId',
        params: { groupId },
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

/**
 * 删除车辆关联
 * @param {Number} id - 关联ID
 */
export function deleteVehicleGroupRelation(id) {
    return axios({
        method: 'get',
        url: '/user/vehicleGroupRelation/delete',
        params: { id },
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}
